import {Injectable} from '@angular/core';
import {initializeApp, getApps} from 'firebase/app';
import {getMessaging, getToken, isSupported} from 'firebase/messaging';
import {from, Observable, of} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {environment} from '@env';

@Injectable({providedIn: 'root'})
export class FcmService {

  private messaging: any = null;

  constructor() {
    try {
      const app = getApps().length ? getApps()[0] : initializeApp(environment.firebase);
      this.messaging = getMessaging(app);
    } catch (e) {
      console.warn('Firebase init failed', e);
    }
  }

  getFcmToken(): Observable<string | null> {
    return from(isSupported()).pipe(
      switchMap(supported => {
        if (!supported || !this.messaging) return of(null);
        return from(
          Notification.requestPermission().then(permission => {
            if (permission !== 'granted') return null;
            return getToken(this.messaging, {vapidKey: environment.firebase.vapidKey});
          })
        );
      }),
      catchError(err => {
        console.warn('Get FCM token failed', err);
        return of(null);
      })
    );
  }
}
